import { Guid } from "guid-typescript";
import QueuedExportFile from "./QueuedExportFile";

class QueuedExport {
    id: Guid;
    title: string;
    createdOn: Date;
    createdBy: number;
    complete: boolean;
    exporT_Files: QueuedExportFile[];

    get hasErrors(): boolean {
        return this.exporT_Files.some(
            item => item.completedOn && !item.azureURL,
        );
    }

    get completedOn(): Date {
        if (!this.complete) return null;

        const completedDates = this.exporT_Files.map(item => item.completedOn);

        return new Date(
            Math.max(...completedDates.map(date => date.getTime())),
        );
    }

    constructor(data: Partial<QueuedExport>, index?: number) {
        Object.assign(this, data);

        if (typeof this.createdOn === "string")
            this.createdOn = new Date(this.createdOn);

        if (this.exporT_Files instanceof Array)
            this.exporT_Files = this.exporT_Files.map(
                item => new QueuedExportFile(item),
            );

            if (index !== undefined) {
                this.title = `Export Bundle ${index + 1}`;
            }
    }
}

export default QueuedExport;
